import React, { useEffect, useState } from "react";
import wellness_web from "../assets/web-yoga.jpg";
import wellness_mob from "../assets/Mob-yoga.jpg";
import TTFont from "../assets/fonts/TT Ramillas Trial Regular.ttf";

const WellnessRetreat = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenReg, setIsOpenReg] = useState(false);
  const [isOpenAcco, setIsOpenAcco] = useState(false);
  const [isOpenAccoTwo, setIsOpenAccoTwo] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `https://strapi.srmd.org/api/wellness-retreat-2025?populate[0]=schedule.scheduleLineItem&populate[1]=schedule.scheduleTableTitles&populate[2]=registration.registrationLineItem&populate[3]=accomodations.onSiteAccommodations&populate[4]=accomodations.onSiteLineItems&populate[5]=accomodations.hotelDetails&populate[6]=stepsForRegistration.listItems&populate[7]=additionalInformation.listItems&populate[8]=sponsorshipInfo.sponsorshipLineItem&populate[9]=contactDetails`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${process.env.REACT_APP_USA_API_TOKEN}`,
            },
          }
        );
        if (!response.ok) {
          setLoading(false);
          throw new Error("Failed to fetch data");
        }

        const result = await response.json();
        setData(result.data); // Storing only the 'data' object
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="bg-[#ffffff]">
      <>
        <img
          src={wellness_web}
          alt={"wellness_web"}
          class="hidden md:block w-full h-auto object-cover"
        />
        <img
          src={wellness_mob}
          alt={"wellness_mob"}
          class="block md:hidden w-full h-auto object-cover"
        />
      </>
      {/* Loader Section */}
      {loading && (
        <div className="flex justify-center items-center py-2 min-h-[100vh]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="5.5em"
            height="5.5em"
            viewBox="0 0 24 24"
          >
            <path
              fill="#e1bcb6"
              d="M20.27,4.74a4.93,4.93,0,0,1,1.52,4.61,5.32,5.32,0,0,1-4.1,4.51,5.12,5.12,0,0,1-5.2-1.5,5.53,5.53,0,0,0,6.13-1.48A5.66,5.66,0,0,0,20.27,4.74ZM12.32,11.53a5.49,5.49,0,0,0-1.47-6.2A5.57,5.57,0,0,0,4.71,3.72,5.17,5.17,0,0,1,9.53,2.2,5.52,5.52,0,0,1,13.9,6.45,5.28,5.28,0,0,1,12.32,11.53ZM19.2,20.29a4.92,4.92,0,0,1-4.72,1.49,5.32,5.32,0,0,1-4.34-4.05A5.2,5.2,0,0,1,11.6,12.5a5.6,5.6,0,0,0,1.51,6.13A5.63,5.63,0,0,0,19.2,20.29ZM3.79,19.38A5.18,5.18,0,0,1,2.32,14a5.3,5.3,0,0,1,4.59-4,5,5,0,0,1,4.58,1.61,5.55,5.55,0,0,0-6.32,1.69A5.46,5.46,0,0,0,3.79,19.38ZM12.23,12a5.11,5.11,0,0,0,3.66-5,5.75,5.75,0,0,0-3.18-6,5,5,0,0,1,4.42,2.3,5.21,5.21,0,0,1,.24,5.92A5.4,5.4,0,0,1,12.23,12ZM11.76,12a5.18,5.18,0,0,0-3.68,5.09,5.58,5.58,0,0,0,3.19,5.79c-1,.35-2.9-.46-4-1.68A5.51,5.51,0,0,1,11.76,12ZM23,12.63a5.07,5.07,0,0,1-2.35,4.52,5.23,5.23,0,0,1-5.91.2,5.24,5.24,0,0,1-2.67-4.77,5.51,5.51,0,0,0,5.45,3.33A5.52,5.52,0,0,0,23,12.63ZM1,11.23a5,5,0,0,1,2.49-4.5,5.23,5.23,0,0,1,5.81-.06,5.3,5.3,0,0,1,2.61,4.74A5.56,5.56,0,0,0,6.56,8.06,5.71,5.71,0,0,0,1,11.23Z"
            >
              <animateTransform
                attributeName="transform"
                dur="1.5s"
                repeatCount="indefinite"
                type="rotate"
                values="0 12 12;360 12 12"
              />
            </path>
          </svg>
        </div>
      )}

      {/* Header Section */}
      {!loading && (
        <div className="text-center mt-2">
          <h2
            style={{ fontFamily: "TT Ramillas, serif", src: `url(${TTFont})`, paddingTop: '10px', paddingBottom: '10px' }}
            className="text-5xl font-medium text-[#d1980b]"
          >
            {data?.title} {data?.subTitle}
          </h2>
          <p className="mt-2 px-0 sm:px-36">
            {data?.description?.split("\\n").map((line, index) => (
              <React.Fragment key={index}>
                {line?.trim()} {/* Trim to remove unnecessary spaces */}
                <br />
              </React.Fragment>
            ))}
          </p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://register.srmd.org/events/YRW2501"
          >
            <button className="mt-4 bg-[#622F36] text-[#fff9f1]  hover:bg-[#e1bcb6] hover:text-[#622F36] px-4 sm:px-6 py-2 font-semibold rounded shadow-md ">
              REGISTER NOW
            </button>
          </a>
        </div>
      )}

      {/* Schedule Section */}
      {/* <div className="max-w-3xl mx-auto mt-8">
        <h2 className="text-lg sm:text-xl font-bold text-orange-600 ">
          Schedule
        </h2>
        <div className="overflow-x-auto mt-4">
          <table className="w-full max-w-full sm:max-w-4xl mx-auto border-collapse border border-[#862f2f]">
            <thead>
              <tr className="bg-[#862f2f] text-white">
                <th className="border p-2">Date</th>
                <th className="border p-2">Early Morning</th>
                <th className="border p-2">Morning</th>
                <th className="border p-2">Afternoon</th>
                <th className="border p-2">Evening</th>
                <th className="border p-2">Dress Code</th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white text-center">
                <td className="border p-2">Thu, Apr 24</td>
                <td className="border p-2">--</td>
                <td className="border p-2">--</td>
                <td className="border p-2">--</td>
                <td className="border p-2">Check-in</td>
                <td className="border p-2">--</td>
              </tr>
              <tr className="bg-gray-100 text-center">
                <td className="border p-2">Fri, Apr 25</td>
                <td className="border p-2">Ajnabhakti</td>
                <td className="border p-2">Sadguru Udghosh</td>
                <td className="border p-2">Wellness Retreat Session 1</td>
                <td className="border p-2 text-red-500">??</td>
                <td className="border p-2">White</td>
              </tr>
              <tr className="bg-white text-center">
                <td className="border p-2">Sat, Apr 26</td>
                <td className="border p-2">Ajnabhakti</td>
                <td className="border p-2">Sadguru Udghosh</td>
                <td className="border p-2">Wellness Retreat Session 2</td>
                <td className="border p-2 text-red-500">??</td>
                <td className="border p-2">White</td>
              </tr>
              <tr className="bg-gray-100 text-center">
                <td className="border p-2">Sun, Apr 27</td>
                <td className="border p-2">Wellness Retreat Session 3</td>
                <td className="border p-2">Sadguru Udghosh</td>
                <td className="border p-2">Check-out</td>
                <td className="border p-2">--</td>
                <td className="border p-2">White</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="max-w-3xl mx-auto mt-8">
        <div className="overflow-x-auto mt-4">
          <table className="w-full max-w-full sm:max-w-4xl mx-auto border-collapse border border-[#862f2f]">
            <thead>
              <tr className="bg-[#862f2f] text-white">
                <th className="border p-2">Date</th>
                <th className="border p-2">Early Morning</th>
                <th className="border p-2">Morning</th>
                <th className="border p-2">Afternoon</th>
                <th className="border p-2">Evening</th>
                <th className="border p-2">Dress Code</th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white text-center">
                <td className="border p-2">Fri, Apr 25</td>
                <td className="border p-2">Ajnabhakti</td>
                <td className="border p-2">Check-in</td>
                <td className="border p-2">Wellness retreat session-1</td>
                <td className="border p-2">Sadguru Udghosh</td>
                <td className="border p-2">White</td>
              </tr>
              <tr className="bg-white text-center">
                <td className="border p-2">Sat, Apr 26</td>
                <td className="border p-2">Ajnabhakti</td>
                <td className="border p-2">Sadguru Udghosh</td>
                <td className="border p-2">Wellness Retreat Session 2</td>
                <td className="border p-2 text-red-500">??</td>
                <td className="border p-2">White</td>
              </tr>
              <tr className="bg-gray-100 text-center">
                <td className="border p-2">Sun, Apr 27</td>
                <td className="border p-2">Wellness Retreat Session 3</td>
                <td className="border p-2">Sadguru Udghosh</td>
                <td className="border p-2">Check-out</td>
                <td className="border p-2">--</td>
                <td className="border p-2">White</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> */}

      {/* Registration Section */}
      {/* {!loading && data?.registration && (
        <div className="max-w-3xl mx-auto mt-8">
          <div className="w-full max-w-full sm:max-w-4xl mx-auto">
            <h2 className="text-lg sm:text-xl font-bold text-orange-600 ">
              {data?.registration?.registrationTitle}
            </h2>
            <div className="overflow-x-auto mt-4">
              <table className="w-full max-w-full sm:max-w-4xl mx-auto border-collapse border border-[#862f2f]">
                <thead>
                  <tr className="bg-[#862f2f] text-white">
                    <th className="border p-2">
                      {data?.registration?.registrationTitle}
                    </th>
                    <th className="border p-2">
                      {data?.registration?.slab1Title}
                    </th>
                    <th className="border p-2">
                      {data?.registration?.slab2Title}
                    </th>
                    <th className="border p-2">
                      {data?.registration?.slab3Title}
                    </th>
                    <th className="border p-2">
                      {data?.registration?.slab4Title}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.registration.registrationLineItem.map((item) => (
                    <tr key={item.id} className="bg-white text-center">
                      <td className="border p-2 font-bold">
                        {item?.registration}
                      </td>
                      <td className="border p-2">{item?.slab1Price}</td>
                      <td className="border p-2">{item?.slab2Price}</td>
                      <td className="border p-2">{item?.slab3Price}</td>
                      <td className="border p-2">{item?.slab4Price}</td>
                    </tr>
                  ))}

                  {data?.registration.registrationLinkText && (
                    <tr className="bg-gray-100 text-center">
                      <td className="border p-2 font-bold">
                        {data?.registration.registrationLinkText}
                      </td>
                      <td className="border p-3" colSpan={4}>
                        <a
                          href={data?.registration.registrationLink}
                          className="bg-[#862f2f] text-white px-4 py-2 rounded-md hover:bg-[#6e2424]"
                        >
                          &lt; {data?.registration.registrationLinkText} &gt;
                        </a>
                      </td>
                    </tr>
                  )}

                  {data?.registration.cancellationPolicyText && (
                    <tr className="bg-white text-center">
                      <td className="border p-2 font-bold">
                        {data?.registration.cancellationPolicyText}
                      </td>
                      <td className="border p-2" colSpan={4}>
                        {
                          data?.registration.cancellationPolicyDetail.split(
                            "\n"
                          )[0]
                        }
                        <br />
                        {
                          data?.registration.cancellationPolicyDetail.split(
                            "\n"
                          )[1]
                        }
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )} */}
      {!loading && (
        <div className="px-0 sm:px-36">
          {data?.schedule && !loading && (
            <div
              id="Schedule"
              className="bg-[#ffffff] p-2 sm:p-8 overflow-x-auto"
            >
              <div
                className="flex justify-between items-center cursor-pointer text-[#622F36]"
                onClick={() => setIsOpen(!isOpen)}
              >
                <h2 className="text-xl font-bold  mb-4">Schedule</h2>
                <span className="block md:hidden mb-4">
                  {isOpen ? (
                    <svg
                      height="24"
                      viewBox="0 0 48 48"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current"
                    >
                      <path d="M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z" />
                      <path d="M0 0h48v48h-48z" fill="none" />
                    </svg>
                  ) : (
                    <svg
                      height="24"
                      viewBox="0 0 48 48"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current"
                    >
                      <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
                      <path d="M0-.75h48v48h-48z" fill="none" />
                    </svg>
                  )}
                </span>
              </div>
              <table className="hidden md:table w-full border  border-black">
                <thead>
                  <tr className="bg-[#622F36] text-[#fff9f1]">
                    {data?.schedule?.scheduleTableTitles.map((item) => (
                      <th
                        key={item.id}
                        className="py-2 px-4 border border-black whitespace-nowrap"
                      >
                        {item?.title}
                        <br /> {item?.subTitle}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data?.schedule.scheduleLineItem.map((item) => (
                    <tr key={item.id} className="text-center  border-black">
                      <td className="py-2 px-4 border  border-black">
                        {item.date}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item?.earlyMorningTitle}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.morningEvent}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.afternoonEvent}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.eveningEvent}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.dressCode}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {isOpen && (
                <div className="flex md:hidden  flex-col">
                  {data?.schedule.scheduleLineItem.map((item, index) => (
                    <div
                      key={item.id}
                      className="border border-black text-center text-[#622F36]"
                    >
                      <h1 className="bg-[#622F36] text-[#fff9f1] py-2 text-lg font-semibold">
                        {data?.schedule.scheduleTableTitles[0]?.title}
                        {data?.schedule.scheduleTableTitles[0]?.subTitle}
                      </h1>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        {item.date}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[1]?.title}
                        </strong>
                        <br />
                        {item.earlyMorningTitle}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[2]?.title}
                        </strong>
                        <br />
                        {item.morningEvent}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[3]?.title}
                        </strong>
                        <br /> {item.afternoonEvent}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[4]?.title}
                        </strong>
                        <br /> {item.eveningEvent}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[5]?.title}
                        </strong>
                        <br /> {item.dressCode}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          {!loading && data?.stepsForRegistration[0] && (
            <div className="p-2 sm:p-8 overflow-x-auto">
              <h2 className="text-xl font-bold  mb-2 text-[#622F36]">Registration Process</h2>
              <ul className="list-disc  text-black">
                <div className="mt-2">
                  <strong className="inline">
                    {
                      data?.stepsForRegistration[0]?.listItems[0]?.value?.split(
                        "\n"
                      )[0]
                    }{" "}
                    -
                  </strong>
                  <p className="inline">
                    {" "}
                    {
                      data?.stepsForRegistration[0]?.listItems[0]?.value?.split(
                        "\n"
                      )[1]
                    }
                  </p>
                </div>
                <br />
                <div className="mt-2">
                  <strong className="inline mt-5">
                    {
                      data?.stepsForRegistration[0]?.listItems[1]?.value?.split(
                        "\n"
                      )[0]
                    }{" "}
                    -
                  </strong>
                  <p className="inline">
                    {" "}
                    {
                      data?.stepsForRegistration[0]?.listItems[1]?.value?.split(
                        "\n"
                      )[1]
                    }
                  </p>
                </div>
                <br />
                <div className="mt-2">
                  <strong className="inline mt-5">
                    {
                      data?.stepsForRegistration[0]?.listItems[2]?.value?.split(
                        "\n"
                      )[0]
                    }{" "}
                    -
                  </strong>
                  <p className="inline">
                    {" "}
                    {
                      data?.stepsForRegistration[0]?.listItems[2]?.value?.split(
                        "\n"
                      )[1]
                    }
                  </p>
                </div>
              </ul>
            </div>
          )}
          {data?.registration && !loading && (
            <div id="Registration" className=" p-2 sm:p-8 overflow-x-auto">
              <div
                className="flex justify-between items-center cursor-pointer text-[#622F36]"
                onClick={() => setIsOpenReg(!isOpenReg)}
              >
                <h2 className="text-xl font-bold  mb-4">Registration</h2>
                <span className="block md:hidden mb-4">
                  {isOpenReg ? (
                    <svg
                      height="24"
                      viewBox="0 0 48 48"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current"
                    >
                      <path d="M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z" />
                      <path d="M0 0h48v48h-48z" fill="none" />
                    </svg>
                  ) : (
                    <svg
                      height="24"
                      viewBox="0 0 48 48"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current"
                    >
                      <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
                      <path d="M0-.75h48v48h-48z" fill="none" />
                    </svg>
                  )}
                </span>
              </div>
              <table className="hidden md:table w-full border  border-black">
                <thead>
                  <tr className="bg-[#622F36] text-[#fff9f1]">
                    <th className="py-2 px-4 border border-black whitespace-nowrap">
                      {data?.registration.registrationTitle}
                    </th>
                    <th className="py-2 px-4 border border-black whitespace-nowrap">
                      {data?.registration?.slab1Title?.split("\\n")[0]}
                      <br />
                      {`${data?.registration?.slab1Title?.split("\\n")[1]}`}
                    </th>
                    <th className="py-2 px-4 border border-black whitespace-nowrap">
                      {data?.registration?.slab2Title?.split("\\n")[0]}
                      <br />
                      {`${data?.registration?.slab2Title?.split("\\n")[1]}`}
                    </th>
                    <th className="py-2 px-4 border border-black whitespace-nowrap">
                      {data?.registration?.slab3Title?.split("\\n")[0]}
                      <br />
                      {`${data?.registration?.slab3Title?.split("\\n")[1]}`}
                    </th>
                    <th className="py-2 px-4 border border-black whitespace-nowrap">
                      {data?.registration?.slab4Title?.split("\\n")[0]}
                      <br />
                      {`${data?.registration?.slab4Title?.split("\\n")[1]}`}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.registration.registrationLineItem.map((item) => (
                    <tr key={item.id} className="text-center  border-black">
                      <td className="py-2 px-4 border  border-black">
                        {item?.registration?.split(" (")[0]}
                        {item?.registration?.includes(" (") && <br />}
                        {item?.registration?.split(" (")[1] &&
                          `(${item.registration.split(" (")[1]}`}
                        {item?.registration?.includes(" (") && <br />}
                        {item?.registration?.split(" (")[2] &&
                          `(${item.registration.split(" (")[2]}`}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.slab1Price}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.slab2Price}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.slab3Price}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.slab4Price}
                      </td>
                    </tr>
                  ))}
                  <tr className="text-center  border-black">
                    <td className="py-2 px-4 border  border-black">
                      {data?.registration.registrationLinkText}
                    </td>
                    <td colSpan="4" className="py-2 px-4 border border-black">
                      <a
                        href={data?.registration?.registrationLink}
                        className="text-[#622F36] hover:underline"
                      >
                        {data.registration.registrationLinkText}
                      </a>
                    </td>
                  </tr>
                  <tr className="text-center  border-black">
                    <td className="py-2 px-4 border  border-black">
                      {data?.registration.cancellationPolicyText}
                    </td>
                    <td colSpan="4" className="py-2 px-4 border border-black">
                      {
                        data.registration.cancellationPolicyDetail?.split(
                          "\\n"
                        )[0]
                      }
                      <br />
                      {`${data.registration.cancellationPolicyDetail?.split(
                        "\\n"
                      )[1]
                        }`}
                    </td>
                  </tr>
                </tbody>
              </table>
              {isOpenReg && (
                <div className="flex md:hidden  flex-col">
                  {data?.registration.registrationLineItem.map((item) => (
                    <div
                      key={item.id}
                      className="border border-black text-center text-[#622F36]"
                    >
                      <h2 className="bg-[#622F36] text-[#fff9f1] py-2 text-lg font-semibold">
                        {item?.registration?.split(" (")[0]}
                        {item?.registration?.includes(" (") && <br />}
                        {item?.registration?.split(" (")[1] &&
                          `(${item.registration.split(" (")[1]}`}
                        {item?.registration?.includes(" (") && <br />}
                        {item?.registration?.split(" (")[2] &&
                          `(${item.registration.split(" (")[2]}`}
                      </h2>
                      <p className="py-2 border-b border-black text-lg font-semibold">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.registration?.slab1Title?.split("\\n")[0]}
                          <br />
                          {`${data?.registration?.slab1Title?.split("\\n")[1]}`}
                        </strong>
                        <br /> {item.slab1Price}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.registration?.slab2Title?.split("\\n")[0]}
                          <br />
                          {`${data?.registration?.slab2Title?.split("\\n")[1]}`}
                        </strong>
                        <br /> {item.slab2Price}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.registration?.slab3Title?.split("\\n")[0]}
                          <br />
                          {`${data?.registration?.slab3Title?.split("\\n")[1]}`}
                        </strong>
                        <br /> {item.slab3Price}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.registration?.slab4Title?.split("\\n")[0]}
                          <br />
                          {`${data?.registration?.slab4Title?.split("\\n")[1]}`}
                        </strong>
                        <br /> {item.slab4Price}
                      </p>
                    </div>
                  ))}
                  <div className="border border-black text-center">
                    <h1 className="bg-[#622F36] text-[#fff9f1] py-2 text-lg font-semibold">
                      {data?.registration.registrationLinkText}
                    </h1>
                    <p className="py-2 border-b border-black text-lg font-semibold">
                      <a
                        href={data?.registration?.registrationLink}
                        className="text-[#622F36] hover:underline"
                      >
                        {data.registration.registrationLinkText}
                      </a>
                    </p>
                  </div>
                  <div className="border border-black text-center">
                    <h1 className="bg-[#622F36] text-[#fff9f1] py-2 text-lg font-semibold">
                      {data?.registration.cancellationPolicyText}
                    </h1>
                    <p className="py-2  border-b border-black text-lg font-semibold">
                      {
                        data.registration.cancellationPolicyDetail?.split(
                          "\\n"
                        )[0]
                      }
                      <br />
                      {`${data.registration.cancellationPolicyDetail?.split(
                        "\\n"
                      )[1]
                        }`}
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}



          {/* Accommodation Section */}
          {data?.accomodations && !loading && (
            <div id="Accommodations" className="mt-8 p-2 sm:p-8">
              <h2 className="text-xl font-bold text-[#622F36] mb-4">
                Accommodations
              </h2>
              <div className="overflow-x-auto">
                <div
                  className="flex justify-between items-center cursor-pointer text-[#622F36]"
                  onClick={() => setIsOpenAcco(!isOpenAcco)}
                >
                  <h3 className="text-md text-gray-600 mb-4">
                    {data?.accomodations?.onSiteTitle}
                  </h3>
                  <span className="block md:hidden mb-4">
                    {isOpenAcco ? (
                      <svg
                        height="24"
                        viewBox="0 0 48 48"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="fill-current"
                      >
                        <path d="M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z" />
                        <path d="M0 0h48v48h-48z" fill="none" />
                      </svg>
                    ) : (
                      <svg
                        height="24"
                        viewBox="0 0 48 48"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="fill-current"
                      >
                        <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
                        <path d="M0-.75h48v48h-48z" fill="none" />
                      </svg>
                    )}
                  </span>
                </div>

                <table className="hidden md:table w-full border  border-black">
                  <thead>
                    <tr className="bg-[#622F36] text-[#fff9f1]">
                      <th className="py-2 px-4 border border-black">
                        {data?.accomodations.onSiteAccommodations?.onSiteTitle}
                      </th>
                      <th className="py-2 px-4 border border-black">
                        {
                          data?.accomodations.onSiteAccommodations?.slab1Title?.split(
                            "\\n"
                          )[0]
                        }
                        <br />
                        {
                          data?.accomodations.onSiteAccommodations?.slab1Title?.split(
                            "\\n"
                          )[1]
                        }
                      </th>
                      <th className="py-2 px-4 border border-black">
                        {
                          data?.accomodations.onSiteAccommodations?.slab2Title?.split(
                            "\\n"
                          )[0]
                        }
                        <br />
                        {
                          data?.accomodations.onSiteAccommodations?.slab2Title?.split(
                            "\\n"
                          )[1]
                        }
                      </th>
                      <th className="py-2 px-4 border border-black">
                        {
                          data?.accomodations.onSiteAccommodations?.slab3Title?.split(
                            "\\n"
                          )[0]
                        }
                        <br />
                        {
                          data?.accomodations.onSiteAccommodations?.slab3Title?.split(
                            "\\n"
                          )[1]
                        }
                      </th>
                      <th className="py-2 px-4 border border-black">
                        {
                          data?.accomodations.onSiteAccommodations?.slab4Title?.split(
                            "\\n"
                          )[0]
                        }
                        <br />
                        {
                          data?.accomodations.onSiteAccommodations?.slab4Title?.split(
                            "\\n"
                          )[1]
                        }
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.accomodations.onSiteLineItems.map((item) => (
                      <tr key={item.id} className="text-center  border-black">
                        <td className="py-2 px-4 border  border-black">
                          {item.OnSiteDetail?.split(" (")[0]}
                          <br />
                          {" ("}
                          {item.OnSiteDetail?.split(" (")[1]}
                        </td>
                        <td className="py-2 px-4 border  border-black">
                          {item.slab1Price?.split("\\n")[0]}
                          <br />
                          {item.slab1Price?.split("\\n")[1]}
                        </td>
                        <td className="py-2 px-4 border  border-black">
                          {item.slab2Price?.split("\\n")[0]}
                          <br />
                          {item.slab2Price?.split("\\n")[1]}
                        </td>
                        <td className="py-2 px-4 border  border-black">
                          {item.slab3Price?.split("\\n")[0]}
                          <br />
                          {item.slab3Price?.split("\\n")[1]}
                        </td>
                        <td className="py-2 px-4 border  border-black">
                          {item.slab4Price?.split("\\n")[0]}
                          <br />
                          {item.slab4Price?.split("\\n")[1]}
                        </td>
                      </tr>
                    ))}

                    <tr className="text-center  border-black">
                      <td className="py-2 px-4 border  border-black">
                        Cancellation Policy
                      </td>
                      <td colSpan="4" className="py-2 px-4 border border-black">
                        {
                          data?.accomodations.onSiteAccommodations?.cancellationPolicyDetails?.split(
                            "\\n"
                          )[0]
                        }
                        <br />
                        {
                          data?.accomodations.onSiteAccommodations?.cancellationPolicyDetails?.split(
                            "\\n"
                          )[1]
                        }
                      </td>
                    </tr>
                  </tbody>
                </table>
                {isOpenAcco && (
                  <div className="flex md:hidden  flex-col">
                    {data?.accomodations.onSiteLineItems.map((item) => (
                      <div
                        key={item.id}
                        className="border border-black text-center text-[#622F36]"
                      >
                        <h1 className="bg-[#622F36] text-[#fff9f1] py-2 text-lg font-semibold">
                          {item.OnSiteDetail}
                        </h1>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            {
                              data?.accomodations.onSiteAccommodations?.slab1Title?.split(
                                "\\n"
                              )[0]
                            }
                            <br />
                            {
                              data?.accomodations.onSiteAccommodations?.slab1Title?.split(
                                "\\n"
                              )[1]
                            }
                          </strong>
                          <br /> {item.slab1Price?.split("\\n")[0]}
                          <br />
                          {item.slab1Price?.split("\\n")[1]}
                        </p>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            {
                              data?.accomodations.onSiteAccommodations?.slab2Title?.split(
                                "\\n"
                              )[0]
                            }
                            <br />
                            {
                              data?.accomodations.onSiteAccommodations?.slab2Title?.split(
                                "\\n"
                              )[1]
                            }
                          </strong>
                          <br />
                          {item.slab2Price?.split("\\n")[0]}
                          <br />
                          {item.slab2Price?.split("\\n")[1]}
                        </p>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            {
                              data?.accomodations.onSiteAccommodations?.slab3Title?.split(
                                "\\n"
                              )[0]
                            }
                            <br />
                            {
                              data?.accomodations.onSiteAccommodations?.slab3Title?.split(
                                "\\n"
                              )[1]
                            }
                          </strong>
                          <br /> {item.slab3Price?.split("\\n")[0]}
                          <br />
                          {item.slab3Price?.split("\\n")[1]}
                        </p>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            {
                              data?.accomodations.onSiteAccommodations?.slab4Title?.split(
                                "\\n"
                              )[0]
                            }
                            <br />
                            {
                              data?.accomodations.onSiteAccommodations?.slab4Title?.split(
                                "\\n"
                              )[1]
                            }
                          </strong>
                          <br /> {item.slab4Price?.split("\\n")[0]}
                          <br />
                          {item.slab4Price?.split("\\n")[1]}
                        </p>
                      </div>
                    ))}

                    <div className="border border-black text-center">
                      <h1 className="bg-[#622F36] text-[#fff9f1] py-2 text-lg font-semibold">
                        Cancellation Policy
                      </h1>
                      <p className="py-2  border-b border-black text-lg font-semibold ">
                        {
                          data?.accomodations.onSiteAccommodations?.cancellationPolicyDetails?.split(
                            "\\n"
                          )[0]
                        }
                        <br />
                        {
                          data?.accomodations.onSiteAccommodations?.cancellationPolicyDetails?.split(
                            "\\n"
                          )[1]
                        }
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className="overflow-x-auto">
                <div
                  className="flex justify-between items-center cursor-pointer text-[#622F36]"
                  onClick={() => setIsOpenAccoTwo(!isOpenAccoTwo)}
                >
                  <h3 className="text-md  text-gray-600 mb-4 mt-4">
                    {data.accomodations.hotelAccommodationsTitle}
                  </h3>
                  <span className="block md:hidden mb-4">
                    {isOpenAccoTwo ? (
                      <svg
                        height="24"
                        viewBox="0 0 48 48"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="fill-current"
                      >
                        <path d="M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z" />
                        <path d="M0 0h48v48h-48z" fill="none" />
                      </svg>
                    ) : (
                      <svg
                        height="24"
                        viewBox="0 0 48 48"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="fill-current"
                      >
                        <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
                        <path d="M0-.75h48v48h-48z" fill="none" />
                      </svg>
                    )}
                  </span>
                </div>

                <table className="hidden md:table w-full border border-black">
                  <thead>
                    <tr className="bg-[#622F36] text-[#fff9f1]">
                      <th className="py-2 px-4 border border-black">
                        Nearby Hotels
                      </th>
                      {data.accomodations.hotelDetails.map((hotel, index) => (
                        <th
                          key={index}
                          className="py-2 px-4 border border-black"
                        >
                          {hotel.name?.includes("(") ? (
                            <>
                              {hotel.name.split("(")[0]}
                              <br />
                              {`(${hotel.name.split("(")[1]}`}
                            </>
                          ) : (
                            hotel.name
                          )}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-center">
                      <td className="py-2 px-4 border border-black">Address</td>
                      {data.accomodations.hotelDetails.map((hotel, index) => (
                        <td
                          key={index}
                          className="py-2 px-4 border border-black"
                        >
                          {hotel.address} <br />({hotel.distance})
                        </td>
                      ))}
                    </tr>
                    <tr className="text-center">
                      <td className="py-2 px-4 border border-black">
                        Hotel Booking
                      </td>
                      {data.accomodations.hotelDetails.map((hotel, index) => (
                        <td
                          key={index}
                          className="py-2 px-4 border border-black"
                        >
                          {hotel?.link && (
                            <a
                              href={hotel.link}
                              target="_blank"
                              rel="noreferrer"
                              className="text-blue-600 hover:underline"
                            >
                              {"["}Link{"]"}
                            </a>
                          )}
                          <br />
                          {hotel.code} <br />
                          {hotel.phone}
                        </td>
                      ))}
                    </tr>
                    <tr className="text-center">
                      <td className="py-2 px-4 border border-black">
                        Cancellation Policy
                      </td>
                      <td
                        colSpan={data.accomodations.hotelDetails.length}
                        className="py-2 px-4 border border-black"
                      >
                        As Per Hotel Policy
                      </td>
                    </tr>
                  </tbody>
                </table>
                {isOpenAccoTwo && (
                  <div className="flex md:hidden  flex-col">
                    {data.accomodations.hotelDetails.map((item) => (
                      <div
                        key={item.id}
                        className="border border-black text-center text-[#622F36]"
                      >
                        <h1 className="bg-[#622F36] text-[#fff9f1] py-2 text-lg font-semibold">
                          {item.name}
                        </h1>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            Address
                          </strong>
                          <br /> {item.address} <br />({item.distance} miles
                          from Venue)
                        </p>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            Hotel Booking
                          </strong>
                          <br />{" "}
                          {item.link && (
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noreferrer"
                              className="text-blue-600 hover:underline"
                            >
                              {"["}Link{"]"}
                            </a>
                          )}
                          <br />
                          {item.code} <br />
                          {item.phone}
                        </p>
                      </div>
                    ))}
                    <div className="border border-black text-center">
                      <h1 className="bg-[#622F36] text-[#fff9f1] py-2 text-lg font-semibold">
                        Cancellation Policy
                      </h1>
                      <p className="py-2 px-2 border-b border-black text-lg font-semibold ">
                        As Per Hotel Policy
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.additionalInformation && !loading && (
            <div
              id="Additional-Information"
              className=" p-2 sm:p-8 overflow-x-auto"
            >
              <h2 className="text-xl font-bold text-[#622F36] mb-4">
                {data?.additionalInformation?.title}
              </h2>
              <ul className="list-disc pl-5 text-gray-800">
                {data.additionalInformation.listItems[0]?.value
                  .split("\n")
                  .map((info, index) => (
                    <li key={index} className="mb-2  text-black">
                      {info.replace(/^- /, "")}
                    </li>
                  ))}
              </ul>
            </div>
          )}

          {/* <div className="max-w-3xl mx-auto mt-8 text-gray-800">
        <h2 className="text-2xl font-bold text-orange-600 mb-4">
          Additional Information
        </h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>The registration fee includes breakfast, lunch, and dinner.</li>
          <li>
            Children under 12 years of age are not allowed in the satsang hall
            during pravachans.
          </li>
          <li>
            The Management will take utmost care of all participants. However,
            the management is not responsible for any injury/loss or damage to
            any individuals or their property during the retreat.
          </li>
          <li>
            Please follow a conservative dress code, no shorts or sleeveless
            clothing.
          </li>
        </ul>

        <h2 className="text-2xl font-bold text-orange-600 mt-8 mb-4">Laabhs</h2>
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-300">
            <thead>
              <tr className="bg-[#862f2f] text-white">
                <th className="border px-4 py-2">Laabhs</th>
                <th className="border px-4 py-2">Laabh Amount</th>
              </tr>
            </thead>
            <tbody className="text-center">
              <tr>
                <td className="border px-4 py-2">Tilak to Pujya Gurudevshri</td>
                <td className="border px-4 py-2">$5,000</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Guru Aarti</td>
                <td className="border px-4 py-2">$2,500</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Aarti Chamar</td>
                <td className="border px-4 py-2">$1,000</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Swamivatsalya - Breakfast</td>
                <td className="border px-4 py-2">$2,000</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Swamivatsalya - Lunch</td>
                <td className="border px-4 py-2">$2,000</td>
              </tr>
              <tr>
                <td className="border px-4 py-2">Swamivatsalya - Dinner</td>
                <td className="border px-4 py-2">$2,000</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ul className="list-disc pl-6 space-y-2 mt-6">
          <li>
            SRMD-USA is a registered public charity in the USA under IRC
            Sections 509(a)(1) and 170(b)(1)(A)(i). All donations are
            tax-deductible to the extent allowed by law.
          </li>
          <li>
            Payment by Credit card via PayPal: Please use{" "}
            <button className="text-blue-600 underline">this link</button> to
            submit your sponsorship contribution via PayPal Giving Fund.
          </li>
          <li>
            Laabh assigned by the Sponsorship team will be final and
            communicated before the event.
          </li>
        </ul>
      </div> */}

          {data?.sponsorshipInfo && !loading && (
            <div id="Sponsorships" className="p-2 sm:p-8 overflow-x-auto">
              <h2 className="text-xl font-bold text-[#622F36] mb-2">
                {data?.sponsorshipInfo?.sponsorshipTitle}
              </h2>
              <table className="hidden md:table w-full border border-black mb-4">
                <thead>
                  <tr className="bg-[#622F36] text-[#fff9f1]">
                    <th className="py-2 px-4 border border-black">#</th>
                    <th className="py-2 px-4 border border-black">
                      {data.sponsorshipInfo.sponsorshipTitle}
                    </th>
                    <th className="py-2 px-4 border border-black">
                      {data.sponsorshipInfo.amountTitle}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.sponsorshipInfo?.sponsorshipLineItem.map(
                    (info, index) => (
                      <tr key={index} className="text-center">
                        <td className="py-2 px-4 border border-black">
                          {index + 1}
                        </td>
                        <td className="py-2 px-4 border border-black">
                          {info?.sponsorshipLineItem}
                        </td>
                        <td className="py-2 px-4 border border-black">
                          {info?.amountLineItem}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              <table className="table md:hidden w-full border border-black mb-4">
                <thead>
                  <tr className="bg-[#622F36] text-[#fff9f1] py-2 text-lg font-semibold">
                    <th className="py-2 px-4 border border-black">#</th>
                    <th className="py-2 px-4 border border-black">
                      {data.sponsorshipInfo.sponsorshipTitle}
                    </th>
                    <th className="py-2 px-4 border border-black">
                      {data.sponsorshipInfo.amountTitle}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.sponsorshipInfo?.sponsorshipLineItem.map(
                    (info, index) => (
                      <tr key={index} className="text-center">
                        <td className="py-2 border border-black text-[#622F36] text-lg font-semibold">
                          {index + 1}
                        </td>
                        <td className="py-2 border-b border-black text-lg font-semibold">
                          {info?.sponsorshipLineItem}
                        </td>
                        <td className="py-2 border border-black text-[#622F36] text-lg font-semibold">
                          {info?.amountLineItem}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              <ul
                className="list-disc pl-5 text-gray-800"
                dangerouslySetInnerHTML={{
                  __html: data?.sponsorshipInfo?.sponsorshipInfo,
                }}
              />
            </div>
          )}

          {data?.contactDetails && !loading && (
            <div
              id="Contact"
              className="bg-[#ffffff] p-2 sm:p-8 overflow-x-auto"
            >
              <h2 className="text-xl font-bold text-[#622F36] mb-4">Contact</h2>
              <p className="text-gray-800 mb-2">
                {data.contactDetails.contactLine}
              </p>
              <p className="text-gray-800 mb-2">
                <i className="fas fa-regular fa-envelope text-[#622F36]"></i>{" "}
                <a
                  href={`mailto:${data.contactDetails.emailLink}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  {data.contactDetails.emailLink}
                </a>
                <br />
                <i className="fas fa-brands fa-whatsapp text-[#622F36]"></i>{" "}
                <a
                  href={data.contactDetails.whatsappUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  {data.contactDetails.whatsappNumber}
                </a>

              </p>
            </div>
          )}
        </div>
      )}

      {/* <div className="max-w-3xl mx-auto mt-8 text-gray-800">
        <h2 className="text-2xl font-bold text-orange-600 mt-8 mb-4">
          Contact
        </h2>
        <p>
          For any questions regarding Registration and Accomodation, please
          email registration@srmdusa.org or contact us on WhatsApp at +1
          862-348-9985{" "}
        </p>
      </div> */}
    </div>
  );
};

export default WellnessRetreat;
